import type { AnalyticsState, GetterClass } from '../../../models'

export class SelectedIdGetter implements GetterClass {
  static execute(this: void, state: AnalyticsState): string {
    return state.selectedId
  }
}
